import { Directive, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[appDnd]',
  host: {
    '(drop)': 'ondrop($event)',
    '(dragleave)': 'onDragleave($event)',
    '(dragenter)': 'onDragenter($event)',
    '(dragover)': 'onDragOver($event)',
  },
})
export class DndDirective {
  /* to make handle drop event on our own we need to prevent drop, leave and over */
  @Output() dndDrop = new EventEmitter<FileList>();
  @Output() dndOver = new EventEmitter<DragEvent>();
  @Output() dndEnter = new EventEmitter<DragEvent>();
  @Output() dndLeave = new EventEmitter<DragEvent>();

  ondrop(e: DragEvent): void {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      this.dndDrop.emit(files);
    }
  }

  onDragleave(e: DragEvent): void {
    e.preventDefault();
    e.stopPropagation();
    this.dndLeave.emit(e);
  }

  onDragenter(e: DragEvent): void {
    e.preventDefault();
    e.stopPropagation();
    this.dndEnter.emit(e);
  }

  onDragOver(e: DragEvent): void {
    e.preventDefault();
    e.stopPropagation();
    this.dndOver.emit(e);
  }
}
